export const ACTIVITY_DATA_REQUESTED = 'ACTIVITY_DATA_REQUESTED';
export const ACTIVITY_DATA_REQUEST_SUCCEEDED =
    'ACTIVITY_DATA_REQUEST_SUCCEEDED';
export const ACTIVITY_DATA_REQUEST_FAILED = 'ACTIVITY_DATA_REQUEST_FAILED';
export const ACTIVITY_DETAIL_REQUESTED = 'ACTIVITY_DETAIL_REQUESTED';
export const ACTIVITY_DETAIL_REQUEST_SUCCEEDED =
    'ACTIVITY_DETAIL_REQUEST_SUCCEEDED';
export const ACTIVITY_DETAIL_REQUEST_FAILED = 'ACTIVITY_DETAIL_REQUEST_FAILED';
export const ACTIVITY_SHARE_URL_REQUESTED = 'ACTIVITY_SHARE_URL_REQUESTED';
export const ACTIVITY_SHARE_URL_REQUEST_SUCCEEDED =
    'ACTIVITY_SHARE_URL_REQUEST_SUCCEEDED';
export const ACTIVITY_SHARE_URL_REQUEST_FAILED =
    'ACTIVITY_SHARE_URL_REQUEST_FAILED';
export const ACTIVITY_LIKE_REQUESTED = 'ACTIVITY_LIKE_REQUESTED';
export const ACTIVITY_LIKE_REQUEST_SUCCEEDED =
    'ACTIVITY_LIKE_REQUEST_SUCCEEDED';
export const ACTIVITY_LIKE_REQUEST_FAILED = 'ACTIVITY_LIKE_REQUEST_FAILED';
export const ACTIVITY_ADD_COMMENT_REQUESTED = 'ACTIVITY_ADD_COMMENT_REQUESTED';
export const ACTIVITY_ADD_COMMENT_REQUEST_SUCCEEDED =
    'ACTIVITY_ADD_COMMENT_REQUEST_SUCCEEDED';
export const ACTIVITY_ADD_COMMENT_REQUEST_FAILED =
    'ACTIVITY_ADD_COMMENT_REQUEST_FAILED';
export const ACTIVITY_CLEAR_ERRORS = 'ACTIVITY_CLEAR_ERRORS';
export const CLEAR_ACTIVITIES = 'CLEAR_ACTIVITIES';
export const EDIT_ACTIVITY_REQUESTED = 'EDIT_ACTIVITY_REQUESTED';
export const EDIT_ACTIVITY_REQUEST_SUCCEEDED =
    'EDIT_ACTIVITY_REQUEST_SUCCEEDED';
export const EDIT_ACTIVITY_REQUEST_FAILED = 'EDIT_ACTIVITY_REQUEST_FAILED';
export const REMOVE_PHOTO_REQUESTED = 'REMOVE_PHOTO_REQUESTED';
export const REMOVE_PHOTO_REQUEST_SUCCEEDED = 'REMOVE_PHOTO_REQUEST_SUCCEEDED';
export const REMOVE_PHOTO_REQUEST_FAILED = 'REMOVE_PHOTO_REQUEST_FAILED';
export const RELOAD_WINDOW = 'RELOAD_WINDOW';
export const REMOVE_POST_REQUESTED = 'REMOVE_POST_REQUESTED';
export const REMOVE_POST_REQUEST_SUCCEEDED = 'REMOVE_POST_REQUEST_SUCCEEDED';
export const REMOVE_POST_REQUEST_FAILED = 'REMOVE_POST_REQUEST_FAILED';

export const removePostRequested = ({ actionId, communityId, activityId }) => ({
    type: REMOVE_POST_REQUESTED,
    payload: {
        actionId,
        communityId,
        activityId,
    },
});
export const removePostRequestSucceeded = (
    activity,
    activityId,
    activitiesType,
) => ({
    type: REMOVE_POST_REQUEST_SUCCEEDED,
    payload: {
        activity,
        activityId,
        activitiesType,
    },
});
export const removePostRequestFailed = (errors) => ({
    type: REMOVE_POST_REQUEST_FAILED,
    payload: {
        errors,
    },
});
export const removePhotoRequested = ({
    actionId,
    communityId,
    activityId,
}) => ({
    type: REMOVE_PHOTO_REQUESTED,
    payload: {
        actionId,
        communityId,
        activityId,
    },
});

export const removePhotoRequestSucceeded = (activity) => ({
    type: REMOVE_PHOTO_REQUEST_SUCCEEDED,
    payload: {
        activity,
    },
});

export const removePhotoRequestFailed = (errors) => ({
    type: REMOVE_PHOTO_REQUEST_FAILED,
    payload: {
        errors,
    },
});
export const activityDataRequested = (activitiesType, options) => ({
    type: ACTIVITY_DATA_REQUESTED,
    payload: {
        activitiesType,
        options,
    },
});
export const editActivityRequested = ({
    actionId,
    communityId,
    options,
    activityId,
}) => ({
    type: EDIT_ACTIVITY_REQUESTED,
    payload: {
        actionId,
        communityId,
        options,
        activityId,
    },
});
export const editActivityRequestSucceeded = (activity) => ({
    type: EDIT_ACTIVITY_REQUEST_SUCCEEDED,
    payload: {
        activity,
    },
});
export const editActivityRequestFailed = (errors, status) => ({
    type: EDIT_ACTIVITY_REQUEST_FAILED,
    payload: {
        errors,
        status,
    },
});
export const activityDataRequestFailed = (activitiesType, errors) => ({
    type: ACTIVITY_DATA_REQUEST_FAILED,
    payload: {
        activitiesType,
        errors,
    },
});
export const activityDataRequestSucceeded = (
    activitiesType,
    newActivityData,
    skip,
) => ({
    type: ACTIVITY_DATA_REQUEST_SUCCEEDED,
    payload: {
        activitiesType,
        newActivityData,
        skip,
    },
});
export const activityDetailRequested = (activityId) => ({
    type: ACTIVITY_DETAIL_REQUESTED,
    payload: {
        activityId,
    },
});
export const activityDetailRequestSucceeded = (activity) => ({
    type: ACTIVITY_DETAIL_REQUEST_SUCCEEDED,
    payload: {
        activity,
    },
});
export const activityDetailRequestFailed = (errors) => ({
    type: ACTIVITY_DETAIL_REQUEST_FAILED,
    payload: {
        errors,
    },
});
export const activityShareURLRequested = (activityId) => ({
    type: ACTIVITY_SHARE_URL_REQUESTED,
    payload: {
        activityId,
    },
});
export const activityShareURLRequestSucceeded = (activityId, url) => ({
    type: ACTIVITY_SHARE_URL_REQUEST_SUCCEEDED,
    payload: {
        activityId,
        url,
    },
});
export const activityShareURLRequestFailed = (errors) => ({
    type: ACTIVITY_SHARE_URL_REQUEST_FAILED,
    payload: {
        errors,
    },
});
export const activityLikeRequested = (activityId, like) => ({
    type: ACTIVITY_LIKE_REQUESTED,
    payload: {
        activityId,
        like,
    },
});
export const activityLikeRequestSucceeded = (activity) => ({
    type: ACTIVITY_LIKE_REQUEST_SUCCEEDED,
    payload: {
        activity,
    },
});
export const activityLikeRequestFailed = (errors) => ({
    type: ACTIVITY_LIKE_REQUEST_FAILED,
    payload: {
        errors,
    },
});
export const addCommentRequested = (activityId, comment) => ({
    type: ACTIVITY_ADD_COMMENT_REQUESTED,
    payload: {
        activityId,
        comment,
    },
});
export const addCommentRequestSucceeded = (activity) => ({
    type: ACTIVITY_ADD_COMMENT_REQUEST_SUCCEEDED,
    payload: {
        activity,
    },
});
export const addCommentRequestFailed = (errors) => ({
    type: ACTIVITY_ADD_COMMENT_REQUEST_FAILED,
    payload: {
        errors,
    },
});

export const clearActivityErrors = () => ({
    type: ACTIVITY_CLEAR_ERRORS,
});

export const clearActivities = (activitiesType) => ({
    type: CLEAR_ACTIVITIES,
    payload: {
        activitiesType,
    },
});
